import { Link } from "react-router-dom";
import { categories, articles } from "@/mocks/articles";
import SectionHeading from "@/components/base/SectionHeading";

export default function CategorySection() {
  const list = categories.filter((item) => item.id !== "all");

  return (
    <section id="categories" className="w-full px-4 md:px-10 py-16 md:py-24">
      <SectionHeading
        eyebrow="主题分类"
        title="想追哪一类，从这里进去"
        desc="我们把散落的热点归成六条主线，按兴趣挑选，比在信息流里瞎刷省事得多。"
      />

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {list.map((cat) => {
          const count = articles.filter((a) => a.categoryId === cat.id).length;
          return (
            <Link
              key={cat.id}
              to={`/hot?cat=${cat.id}`}
              className="group flex items-start gap-4 p-5 rounded-lg border border-background-200 bg-background-50 hover:border-accent-400 hover:bg-accent-50/50 transition-colors"
            >
              <span className="w-12 h-12 shrink-0 rounded-lg bg-secondary-100 text-secondary-700 flex items-center justify-center text-xl group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${cat.icon} w-6 h-6 flex items-center justify-center`}></i>
              </span>
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-base font-semibold text-foreground-950">{cat.name}</h3>
                  <span className="text-[11px] px-2 py-0.5 rounded-full bg-background-200 text-foreground-600">
                    {count} 条
                  </span>
                </div>
                <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{cat.desc}</p>
              </div>
              <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center text-foreground-300 group-hover:text-primary-500 ml-auto shrink-0 transition-colors"></i>
            </Link>
          );
        })}
      </div>
    </section>
  );
}